import { Controller } from "@hotwired/stimulus"

// Flash toast: closes itself after dismissAfter milliseconds when given, otherwise waits for close.
export default class extends Controller {
  static values = { dismissAfter: Number }

  connect() {
    if (this.dismissAfterValue > 0) {
      this.timeout = setTimeout(() => this.close(), this.dismissAfterValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  close() {
    this.element.remove()
  }
}
